import * as React from 'react'
import { FC } from 'react'
import classNames from 'classnames'

import { Tier1Link, Link } from '../../../../../helpers/navStructure'
import MobileTier1MenuItem from './MobileTier1MenuItem'

export interface MobileMenuProps {
  isOpen: boolean
  onClose: () => void
  childLinks: Tier1Link[]
  selectedLink: Tier1Link | null
  onSelectedLink: (link: Tier1Link | null) => void
  highlightedTier2Link: Link | null
  onHighlightedTier2Link: (link: Link | null) => void
  highlightedTier3Link: Link | null
  onHighlightedTier3Link: (link: Link | null) => void
}

const MobileMenu: FC<MobileMenuProps> = ({
  isOpen,
  onClose,
  childLinks,
  selectedLink,
  onSelectedLink,
  highlightedTier2Link,
  onHighlightedTier2Link,
  highlightedTier3Link,
  onHighlightedTier3Link,
}) => {
  const classes = classNames('menu', { open: isOpen })

  return (
    <>
      <style jsx>{`
        .menu {
          display: none;
          position: absolute;
          background: #ffffff;
          width: 100%;
          min-height: 100%;
          z-index: 2;
        }
        .menu-items {
          padding-left: 32px;
          padding-top: 16px;
          flex-direction: column;
          display: flex;
          position: relative;
        }
        .tier2-menu-items {
          padding-left: 64px;
          padding-top: 52px;
          flex-direction: column;
          display: flex;
        }
        .open {
          display: flex;
        }
      `}</style>
      <nav className={classes}>
        <div className="menu-items">
          {childLinks.map((item) => {
            return (
              <MobileTier1MenuItem
                key={item.href}
                tier1Link={item}
                childLinks={item.children}
                onSelect={(): void => {
                  onSelectedLink(item)
                  onHighlightedTier2Link(null)
                  onHighlightedTier3Link(null)
                }}
                isOpen={item === selectedLink}
                onNavigate={onClose}
                highlightedTier2Link={highlightedTier2Link}
                highlightedTier3Link={highlightedTier3Link}
              />
            )
          })}
        </div>
      </nav>
    </>
  )
}

export default MobileMenu
